import React from 'react'
import PropTypes from 'prop-types'

import { Dialog, DialogContent, DialogTitle, Typography, IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Close as CloseIcon } from '@material-ui/icons'

import SchoolMessage from './SchoolMessage'

const titleId = 'school-message-title-id'

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}))

const ContactCounselorModal = ({ open, handleClose, highSchoolId, highSchoolName, contactUserId }) => {
  const classes = useStyles()
  return (
    <Dialog
      fullWidth
      open={open}
      aria-labelledby={titleId}
      onClose={handleClose}
    >
      <DialogTitle
        disableTypography
        id={titleId}
      >
        <Typography variant="h6">{highSchoolName}</Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <SchoolMessage
          highSchoolId={highSchoolId}
          highSchoolName={highSchoolName}
          contactUserId={contactUserId}
        />
      </DialogContent>
    </Dialog>
  )
}
ContactCounselorModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  highSchoolId: PropTypes.string.isRequired,
  highSchoolName: PropTypes.string.isRequired,
  contactUserId: PropTypes.string,
}

export default ContactCounselorModal
